import {
  startLoading
} from '@/plugins/loading'
import http from '@/plugins/api'
import * as types from './types'

export default {
  /**
   * Get video
   * @param {Number} videoId - Video's ID
   */
  async getVideo({
    dispatch
  }, videoId) {
    const r = await startLoading(dispatch, 'getVideo', () =>
      http.get(`videos/get?id=${videoId}`)
    )

    return r.data
  },
  /**
   * Get videos by search
   * @param {Object} params - SearchOptions object
   */
  async getVideosSearch({
    rootState,
    commit,
    dispatch
  }, params) {
    // Remove object reactivity
    params = JSON.parse(JSON.stringify(params))

    // Set market segments by default (used on Upsert User) or assigned the ones selected in the search area (used on Location List)
    if (typeof params.marketSegments !== 'undefined') {
      params.marketSegments = `[${params.marketSegments.join()}]`
    } else {
      params.marketSegments = `[${rootState.video.marketSegments.map(item => item.id).join()}]`
    }

    // Call API
    const r = await startLoading(dispatch, 'getVideosSearch', () =>
      http.get('videos/search', {
        params
      })
    )

    commit(types.SET_VIDEOS, r.data.items)
    return r.data.count
  },
  /**
   * Get market segments
   */
  async getMarketSegments({
    commit,
    dispatch
  }) {
    const r = await startLoading(dispatch, 'getMarketSegments', () =>
      http.get('videos/getMarketSegments')
    )
    commit(types.SET_MARKET_SEGMENTS, r.data)
  },
  /**
   * Create a new video
   * @param {Object} video - Video's data
   */
  async createVideo({
    commit,
    dispatch
  }, video) {
    // Call API
    const r = await startLoading(dispatch, 'createVideo', () =>
      http.post('videos/create', video)
    )

    if (r.data !== '') {
      commit(types.ADD_VIDEO, r.data)
      return r.data
    } else {
      console.error(r)
      throw new Error(`We couldn't add the video.`)
    }
  },
  /**
   * Update an existing video
   * @param {Object} video - Video's data
   */
  async updateVideo({
    dispatch
  }, video) {
    // Call API
    const r = await startLoading(dispatch, 'updateVideo', () =>
      http.post('videos/update', video)
    )
    return r.data
  },
  /**
   * Delete an existing video
   * @param {Object} video - Video's data
   */
  async deleteVideo({
    commit,
    dispatch
  }, video) {
    // Call API
    const r = await startLoading(dispatch, 'deleteVideo', () =>
      http.post('videos/delete', {
        id: video.id
      })
    )

    commit(types.DELETE_VIDEO, video)
    return r.data
  },
  /**
   * Get incomplete videos count
   */
  async getIncompleteVideosCount({
    commit,
    dispatch
  }) {
    // Call API
    const r = await startLoading(dispatch, 'getIncompleteVideosCount', () =>
      http.get('videos/GetIncompleteVideosCount')
    )

    commit(types.SET_INCOMPLETE_VIDEOS_COUNT, r.data)
  },
  /**
   * Create a new User video record
   * @param {Object} userVideo - User Video's data
   */
  async createUserVideo({
    commit,
    dispatch
  }, video) {
    // Call API
    const r = await startLoading(dispatch, 'createUserVideo', () =>
      http.post('videos/createUserVideo', {
        videoId: video.id
      })
    )

    if (r.data !== '') {
      commit(types.UPDATE_INCOMPLETE_VIDEOS_COUNT, +1)
    }
    return r.data
  },
  /**
   * Update a new User video record
   * @param {Object} userVideo - User Video's data
   */
  async updateUserVideo({
    commit,
    dispatch
  }, video) {
    // Call API
    const r = await startLoading(dispatch, 'updateUserVideo', () =>
      http.post('videos/updateUserVideo', {
        id: video.ratingId,
        rating: video.rating
      })
    )

    commit(types.UPDATE_INCOMPLETE_VIDEOS_COUNT, -1)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/video/actions.js